export enum SubscriptionPlanPageRoute {
  MAIN_PAGE = '/',
  CHOOSE_PLAN = '/choose',
  PAYMENT = '/payment',
  WELCOME = '/welcome',
  FREE_PLAN = '/free/choose',
}
